/**
 * 素材種別
 */
export var MaterialTypes;

(function (MaterialTypes) {
  /**
   * モデル
   */
  MaterialTypes[MaterialTypes["Model"] = 0] = "Model";
  /**
   * テクスチャ
   */

  MaterialTypes[MaterialTypes["Texture"] = 1] = "Texture";
  /**
   * ムービー
   */

  MaterialTypes[MaterialTypes["Movie"] = 2] = "Movie";
  /**
   * オーディオ
   */

  MaterialTypes[MaterialTypes["Audio"] = 3] = "Audio";
  /**
   * エフェクト
   */

  MaterialTypes[MaterialTypes["Effect"] = 4] = "Effect";
  /**
   * プリセット
   */

  MaterialTypes[MaterialTypes["Preset"] = 5] = "Preset";
  /**
   * マップ
   */

  MaterialTypes[MaterialTypes["Map"] = 6] = "Map";
  /**
   * アバター
   */

  MaterialTypes[MaterialTypes["Avatar"] = 7] = "Avatar";
  /**
   * ドキュメント
   */

  MaterialTypes[MaterialTypes["Document"] = 8] = "Document";
  /**
   * キャプチャ
   */

  MaterialTypes[MaterialTypes["Photo"] = 9] = "Photo";
  /**
   * イメージ検索
   */

  MaterialTypes[MaterialTypes["ImageSearch"] = 10] = "ImageSearch";
  /**
   * ムービー検索
   */

  MaterialTypes[MaterialTypes["MovieSearch"] = 11] = "MovieSearch";
  /**
   * ファイルプレビュー
   */

  MaterialTypes[MaterialTypes["FilePreview"] = 12] = "FilePreview";
  /**
   * トリガーオブジェクト
   */

  MaterialTypes[MaterialTypes["Empty"] = 13] = "Empty";
  /**
   * ポイントクラウド
   */

  MaterialTypes[MaterialTypes["PointCloud"] = 14] = "PointCloud";
  /**
   * パネル
   */

  MaterialTypes[MaterialTypes["Panel"] = 15] = "Panel";
  /**
   * ホワイトボード
   */

  MaterialTypes[MaterialTypes["Whiteboard"] = 16] = "Whiteboard";
  /**
   * 3Dムービー
   */

  MaterialTypes[MaterialTypes["ThreeDMovie"] = 17] = "ThreeDMovie";
  /**
   * ライブ
   */

  MaterialTypes[MaterialTypes["Live"] = 18] = "Live";
  /**
   * ポータル
   */

  MaterialTypes[MaterialTypes["Portal"] = 19] = "Portal";
  /**
   * ストリーミング
   */

  MaterialTypes[MaterialTypes["Streaming"] = 20] = "Streaming";
  /**
   * ボックスメジャー
   */

  MaterialTypes[MaterialTypes["BoxMeasure"] = 21] = "BoxMeasure";
  /**
   * 3Dテクスチャ
   */

  MaterialTypes[MaterialTypes["ThreeDTexture"] = 22] = "ThreeDTexture";
  /**
   * データパネル
   */

  MaterialTypes[MaterialTypes["DataPanel"] = 23] = "DataPanel";
  /**
   * 360度録画
   */

  MaterialTypes[MaterialTypes["SphereCam"] = 24] = "SphereCam";
  /**
   * 360度メディアスグループ
   */

  MaterialTypes[MaterialTypes["SphereGroup"] = 25] = "SphereGroup";
  /**
   * LCC
   */

  MaterialTypes[MaterialTypes["Lcc"] = 26] = "Lcc";
  /**
   * 不明
   */

  MaterialTypes[MaterialTypes["Unknown"] = 99] = "Unknown";
})(MaterialTypes || (MaterialTypes = {}));